import {createSlice} from '@reduxjs/toolkit';

export type Holding = {
  name: string;
  value: number;
  changeAmount: number;
  changePercent: number;
};

export type Commodity = {
  name: string;
  value: number;
  changeAmount: number;
  changePercent: number;
};

export type Position = {
  id: string;
  assetName: string;
  quantity: number;
  averagePrice: number;
  currentValue: number;
  unrealizedPl: number;
  unrealizedPlPercent: number;
};

export type Order = {
  id: string;
  assetName: string;
  type: 'Buy' | 'Sell';
  quantity: number;
  price?: number; // Optional for market orders
  orderType: 'Limit' | 'Market' | 'Stop';
  status: 'Filled' | 'Pending' | 'Cancelled' | 'Partially Filled';
  timestamp: string;
};

type PortfolioState = {
  value: number;
  keyHoldings: Holding[];
  topCommodities: Commodity[];
  positions: Position[];
  orders: Order[];
};

const initialState: PortfolioState = {
  value: 12_578_940, // From "Portfolio Value"
  keyHoldings: [
    {
      name: 'Gold', value: 2336.45, changeAmount: -5.3, changePercent: -0.23,
    },
    {
      name: 'Crude Oil', value: 83.29, changeAmount: -0.75, changePercent: -0.89,
    },
  ],
  topCommodities: [
    {
      name: 'Corn', value: 4.5, changeAmount: 0.05, changePercent: 1.12,
    },
    {
      name: 'Wheat', value: 6.2, changeAmount: -0.02, changePercent: -0.32,
    },
    {
      name: 'Soybeans', value: 11.8, changeAmount: 0.15, changePercent: 1.29,
    },
  ],
  positions: [
    {
      id: 'pos1', assetName: 'AAPL', quantity: 100, averagePrice: 170.32, currentValue: 17_500, unrealizedPl: 468, unrealizedPlPercent: 2.75,
    },
    {
      id: 'pos2', assetName: 'MSFT', quantity: 50, averagePrice: 330.1, currentValue: 16_800, unrealizedPl: 295, unrealizedPlPercent: 1.79,
    },
    {
      id: 'pos3', assetName: 'TSLA', quantity: 20, averagePrice: 250.75, currentValue: 4800, unrealizedPl: -415, unrealizedPlPercent: -7.96,
    },
  ],
  orders: [
    {
      id: 'ord1', assetName: 'GOOGL', type: 'Buy', quantity: 10, price: 135.5, orderType: 'Limit', status: 'Pending', timestamp: '2025-06-11T10:30:00Z',
    },
    {
      id: 'ord2', assetName: 'AMZN', type: 'Sell', quantity: 5, price: 125, orderType: 'Limit', status: 'Filled', timestamp: '2025-06-10T15:45:00Z',
    },
    {
      id: 'ord3', assetName: 'NVDA', type: 'Buy', quantity: 15, orderType: 'Market', status: 'Filled', timestamp: '2025-06-11T09:15:00Z',
    },
    {
      id: 'ord4', assetName: 'BTC', type: 'Buy', quantity: 0.5, price: 30_000, orderType: 'Limit', status: 'Cancelled', timestamp: '2025-06-09T12:00:00Z',
    },
  ],
};

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {
    // Future actions can go here
  },
});

export default portfolioSlice.reducer;
